<template>
	<div class="certificate-detail">
		<div class="container">
			<img src="../../../assets/images/u5010.jpg" class="logo" />
			<p class="c-title zh">中国美术学院社会美术水平考级</p>
			<p class="c-title en">Graded Examination for Fine Art in Society</p>
			<p class="c-title en">China Academy of Art</p>
			<!-- title -->
			<p class="apply-title">考生信息</p>
			<ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">姓名：</span>
					<span class="a-info">{{ data.student_name }}</span>
				</li>
				<li class="item clearfix" v-if="data.student_pinyin">
					<span class="a-title">姓名全拼：</span>
					<span class="a-info">{{ data.student_pinyin }}</span>
				</li>
				<li class="item clearfix" v-if="data.student_gender">
					<span class="a-title">性别：</span>
					<span class="a-info">{{ data.student_gender }}</span>
				</li>
				<li class="item clearfix" v-if="data.birth || data.student_birth">
					<span class="a-title">出生日期：</span>
					<span class="a-info">{{ data.student_birth }}</span>
				</li>
				<li class="item clearfix" v-if="data.nation_title">
					<span class="a-title">民族：</span>
					<span class="a-info">{{ data.nation_title }}</span>
				</li>
				<li class="item clearfix" v-if="data.country_title">
					<span class="a-title">国籍：</span>
					<span class="a-info">{{ data.country_title }}</span>
				</li>
				<li class="item clearfix" v-if="data.student_id_card || data.passport">
					<span class="a-title">身份证 / 护照：</span>
					<span class="a-info">{{ data.student_id_card }}</span>
				</li>
				<!-- <li class="item clearfix" v-if="data.student_passport">
          <span class="a-title">护照：</span>
          <span class="a-info">{{ data.student_passport }}</span>
        </li> -->
			</ul>
			<!-- title -->
			<p class="apply-title">考级信息</p>
			<ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">报考考级机构：</span>
					<span class="a-info">中国美术学院</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考级专业：</span>
					<span class="a-info">{{ data.subject_title }}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">起止级：</span>
					<span class="a-info">{{ data.subject_range }}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">等级：</span>
					<span class="a-info">{{ data.rank }}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">发证日期：</span>
					<span class="a-info">{{ data.give_time }}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">证书编号：</span>
					<span class="a-info">{{ data.code }}</span>
				</li>
			</ul>
			<p class="search">
				证书官方查询网址：
				<a href="https://kjzx.caa.edu.cn/">https://kjzx.caa.edu.cn/</a>
			</p>
			<!-- <img src="../../../assets/images/yinzhang.png" class="yinzhang" /> -->
			<!-- <div class="btn-wrap clearfix">
				<el-button style="float:left" type="primary" class="btn" @click="$router.go(-1)">返回</el-button>
				<el-button style="float:right" type="primary" class="btn">下载证书</el-button>
			</div>-->
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
	props: {
		data: {
			type: Object,
			default() {
				return {};
			}
		}
	},

	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
.certificate-detail {
	.container {
		width: 750px;
		min-height: 362px;
		border: 1px solid #eaeaea;
		margin: 30px auto;
		margin-bottom: 80px;
		overflow: hidden;
		background: #fffff7;
		position: relative;
		padding-bottom: 50px;
	}
	.yinzhang {
		display: block;
		width: 165px;
		position: absolute;
		bottom: 20px;
		right: 20px;
	}
	.logo {
		display: block;
		margin: 45px auto;
		width: 84px;
	}
	.c-title {
		font-size: 28px;
		text-align: center;
		font-weight: 600;
		font-family: NSimSun, STSong;
		&.en {
			font-size: 18px;
			text-align: center;
			font-weight: 600;
			margin-top: 8px;
			font-family: NSimSun, STSong;
		}
	}
	.apply-title {
		font-size: 28px;
		font-weight: 600;
		// font-style: italic;
		font-family: SimSun, STSong;
		color: #363636;
		margin-top: 45px;
		text-align: center;
	}
	.a-list {
		width: 680px;
		margin: 20px auto;
		.item {
			width: 100%;
			min-height: 46px;
			padding-top: 12px;
			padding-bottom: 15px;
			.a-title {
				width: 180px;
				font-size: 14px;
				color: #363636;
				text-align: right;
				white-space: nowrap;
				float: left;
				border-bottom: 1px solid transparent;
			}
			.a-info {
				width: 500px;
				padding-left: 15px;
				font-size: 14px;
				color: #7a7a7a;
				float: right;
				border-bottom: 1px solid #e7e7e7;
				img {
					width: 122px;
					height: 156px;
				}
			}
		}
	}
	.btn-wrap {
		margin-bottom: 50px;
		overflow: hidden;
		text-align: center;
		width: 684px;
		margin: 0 auto 20px;
		.btn {
			width: 30%;
		}
	}
	.search {
		text-align: center;
	}
}
@media screen and (max-width: 768px) {
	.certificate-detail {
		.container {
			width: 95% !important;
		}
		.yinzhang {
			width: 5rem;
		}
		.logo {
			margin: 1rem auto;
			width: 2rem;
		}
		.c-title {
			font-size: 0.7rem;
			&.en {
				font-size: 0.6rem;
			}
		}
		.apply-title {
			font-size: 0.7rem;
		}
		.a-list {
			width: 100%;
			.item {
				.a-title {
					width: 110px;
					padding-left: 15px;
					text-align: right;
				}
				.a-info {
					width: 60%;
				}
			}
		}
		.btn-wrap {
			width: 100%;
			.btn {
				width: 30%;
			}
		}
	}
}
</style>
